import { useTranslation } from 'react-i18next';

import * as SG from 'styles';

import { Headline } from 'components/Headline';

import { ListItemSkeleton } from '../ListItem';
import { QuickOrderModal } from '../QuickOrderModal';
import { useProductList } from './ProductList.hooks';
import * as S from './ProductList.styles';

const SKELETON_COUNT = 6;

type ProductListProps = {
  isGridChangeSet: Function;
};

export function ProductList(props: ProductListProps): React.ReactElement {
  const { isGridChangeSet } = props;

  const {
    productsMapped,
    isLoading,
    grid,
    isOrderModalVisible,
    isOrderModalVisibleSet,
    content,
  } = useProductList(isGridChangeSet);
  const { t } = useTranslation();

  const showSkeleton = isLoading || (!productsMapped?.length && !content);

  const renderContent = () => {
    if (showSkeleton) {
      return Array.from({ length: SKELETON_COUNT }, (_, i) => (
        <ListItemSkeleton key={i} layout={grid} />
      ));
    }

    if (productsMapped?.length > 0) {
      return productsMapped;
    }

    return (
      <S.EmptyMessage>
        <Headline scale="xl3" textTransform="isFirstLetterUppercase" textAlign="center">
          {t('catalogue.isEmpty')}
        </Headline>
      </S.EmptyMessage>
    );
  };

  return (
    <>
      <SG.Inner>
        <S.Wrapper layout={grid}>{renderContent()}</S.Wrapper>
      </SG.Inner>

      {isOrderModalVisible ? (
        <QuickOrderModal onClose={() => isOrderModalVisibleSet(false)} />
      ) : undefined}
    </>
  );
}
